import { Select, Card, Spin, Divider, Button, Input, Space } from "antd";
import React, { useState, useEffect, useRef } from "react";
import { TagOutlined, PlusOutlined } from '@ant-design/icons';
import { useReactFlow } from '@xyflow/react';
import { CustomHandle } from "../handler/main";
import DeleteNode from "../delete_node/main";

import { fireDB } from "../../../../funcs/firebase";
import { collection, getDocs, addDoc, serverTimestamp, query, orderBy } from "firebase/firestore";

export default function TagContact({ id, data }) {

    const { updateNodeData } = useReactFlow();
    const [selectedTags, setSelectedTags] = useState(data?.tags || []);
    const [allTags, setAllTags] = useState([]);
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState('');
    const inputRef = useRef(null);

    const fetchTags = async () => {
        setLoading(true);
        try {
            const user_detail = JSON.parse(localStorage.getItem("userData"));
            if (!user_detail?.user_id) return;

            const tagsRef = collection(fireDB, "users", user_detail.user_id, "tags");
            const q = query(tagsRef, orderBy("created_at", "desc"));
            const querySnapshot = await getDocs(q);

            const fetchedTags = querySnapshot.docs.map(doc => ({
                label: doc.data().name,
                value: doc.id,
                name: doc.data().name
            }));
            setAllTags(fetchedTags);
        } catch (error) {
            console.error("Error fetching tags:", error);
            if (allTags.length === 0) setAllTags([]);

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTags();
    }, []);


    const handleChange = (value, option) => {
        const tagsData = option.map(opt => ({
            id: opt.value,
            name: opt.label
        }));

        setSelectedTags(value);
        updateNodeData(id, { ...data, tags: value, tagsData: tagsData });
    };

    const addItem = async (e) => {
        e.preventDefault();
        if (!name) return;

        const user_detail = JSON.parse(localStorage.getItem("userData"));
        if (!user_detail?.user_id) return;

        setLoading(true);
        try {
            const tagsRef = collection(fireDB, "users", user_detail.user_id, "tags");
            const docRef = await addDoc(tagsRef, {
                name: name,
                created_at: serverTimestamp()
            });

            const newTag = { label: name, value: docRef.id, name: name };
            setAllTags(prev => [newTag, ...prev]);
            setName('');

            // Auto Select the new tag
            const newSelectedTags = [...selectedTags, docRef.id];
            const newTagsData = [...(data?.tagsData || []), { id: docRef.id, name: name }];

            setSelectedTags(newSelectedTags);
            updateNodeData(id, { ...data, tags: newSelectedTags, tagsData: newTagsData });

            setTimeout(() => {
                inputRef.current?.focus();
            }, 0);
        } catch (error) {
            console.error("Error creating tag:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flow-comp" style={{ minWidth: "250px", maxWidth: "300px", alignItems: 'stretch' }}>
            <CustomHandle type="target" id={`${id}`} />

            <div className="comp-header" style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '8px', marginBottom: '8px' }}>
                <DeleteNode updateNodeData={updateNodeData} id={id} data={data} />
                <p className="comp-title" style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px', margin: 0 }}>
                    <TagOutlined style={{ color: "#722ed1" }} /> Tag Contact
                </p>
            </div>

            <div style={{ padding: "0 10px 10px 10px" }} className="nodrag">
                {/* <p style={{fontSize: "12px", marginBottom: "5px", color: "#666"}}>Add tags to contact:</p> */}
                <Select
                    mode="multiple"
                    style={{ width: "100%" }}
                    placeholder="Select or Create tags"
                    onChange={handleChange}
                    value={selectedTags}
                    options={allTags}
                    loading={loading}
                    maxTagCount="responsive"
                    dropdownRender={(menu) => (
                        <>
                            {menu}
                            <Divider style={{ margin: '8px 0' }} />
                            <Space style={{ padding: '0 8px 4px', width: '100%' }}>
                                <Input
                                    placeholder="New tag name"
                                    ref={inputRef}
                                    value={name}
                                    onChange={(event) => setName(event.target.value)}
                                    onKeyDown={(e) => {
                                        e.stopPropagation();
                                        if (e.key === 'Enter' && name.trim()) {
                                            e.preventDefault();
                                            addItem(e);
                                        }
                                    }}
                                    style={{ flex: 1 }}
                                />
                                <Button type="text" icon={<PlusOutlined />} onClick={addItem} disabled={!name}>
                                    Add
                                </Button>
                            </Space>
                        </>
                    )}
                />
            </div>
            <div style={{ padding: "0 10px 10px 10px" }}>
                <p style={{ fontSize: "11px", color: "#999", margin: 0 }}>Tags will be applied when flow reaches here.</p>
            </div>

            <Button color="default" variant="solid"
                block
                style={{
                    marginBottom: "0",
                    marginTop: "10px"
                }}>
                Next Step {<CustomHandle type="source" id={`${id}`} />}
            </Button>
        </div>
    );
}
